import { FormControl, FormControlProps, FormHelperText, InputLabel } from '@mui/material';
import { Controller, useFormContext, ValidateResult } from 'react-hook-form';
import { CommonFormFieldProps, DateRange, DateRangeValue } from 'src/components';

export type FormDateRangeProps = Omit<
  FormControlProps,
  'required' | 'defaultValue' | 'name'
> & {
  required?: boolean | string;
  name: string;
  label?: string;
  value?: DateRangeValue;
  validate?: (value: DateRangeValue) => ValidateResult;
} & CommonFormFieldProps<'daterange', DateRangeValue | null | undefined>;

export const FormDateRange = (props: FormDateRangeProps) => {
  const { name, label, required, value, defaultValue, validate, ...rest } = props;
  const { control, formState } = useFormContext();
  const error = formState.errors[name];

  return (
    <FormControl {...rest} error={!!error}>
      <Controller
        name={name}
        control={control}
        rules={{
          validate,
        }}
        render={({ field }) => (
          <>
            <InputLabel>{label}</InputLabel>
            <DateRange {...field} />
            {error?.message && typeof error?.message === 'string' ? (
              <FormHelperText error={!!error}>{error.message}</FormHelperText>
            ) : null}
          </>
        )}
      />
    </FormControl>
  );
};
